export default function unixTimestamp(): number {
    if (!Date.now) {
        Date.now = function now() {
            return new Date().getTime();
        };
    }

    return Math.round(Date.now() / 1000);
}
